<template>
  <div style="width:100%;height:250px;margin-top:0px">
    <p slot="header" style="color:#f60;text-align:center">
      <Icon type="md-information-circled"></Icon>
      <span>积分调整</span>
    </p>
    <br/>
    <div style="display:flex;">
      <div>调整值：</div>
      <InputNumber v-model="value2" @on-change='onChangeNumber'/>
    </div>
    <div>调整值值大于零就是添加，小于零就是减少</div>
    <div style="margin-top:20px;">
      <Input
        placeholder="备注"
        type="textarea"
        :rows="5"
        v-model="text"
        @on-change='onChangeContent'
      ></Input>
      <!-- <Select @on-change="onchangeSelect" v-model="model3" style="width:100px">
        <Option
          v-for="item in cityList"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "deal",
  props: {
    // content: {
    //   type: String,
    //   value: "",
    // },
    // e_lnglat: {
    //   type: String,
    //   value: "",
    // },
    // device_id: {
    //   type: String,
    //   value: "",
    // },
    // amap_trid: {
    //   type: String,
    //   value: "",
    // },
  },
  data() {
    return {
      model3: "",
      text: "",
      value2:"",
    };
  },
  created() {},
  mounted() {},
  methods: {
    // onchangeSelect() {
    //   console.log(this.model3);
    //   // 使用$emit 将子组件获取的id值传给父组件
    //   this.$emit("getAction", this.model3);
    // },
    onChangeContent() {
      console.log(this.text);
      this.$emit("getcontent", this.text);
    },
    onChangeNumber() {
      console.log(this.value2);
      this.$emit("getAction", this.value2);
    }
  },
};
</script>
<style lang="less">
// .modelMap {
//   position: relative;
// }
// #containers {
//   margin: 0 auto;
// }
</style>
